import React from 'react';
import { CalendarDays, Leaf, Search, Users, StarIcon } from 'lucide-react';
export type TabType = 'summit' | 'albero' | 'scopri' | 'connections' | 'profilo';
interface TabBarProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}
const TABS: {
  key: TabType;
  label: string;
  Icon: typeof CalendarDays;
}[] = [{
  key: 'summit',
  label: 'Schedule',
  Icon: CalendarDays
}, {
  key: 'albero',
  label: 'Impact',
  Icon: Leaf
}, {
  key: 'scopri',
  label: 'Scopri',
  Icon: Search
}, {
  key: 'connections',
  label: 'Connections',
  Icon: Users
}, {
  key: 'profilo',
  label: 'Best Product',
  Icon: StarIcon
}];
export function TabBar({
  activeTab,
  onTabChange
}: TabBarProps) {
  return <div className="absolute bottom-0 left-0 right-0 w-full h-[72px] bg-[#0D0D0D] border-t border-[#2A2A2A]/50 z-50" style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-387">
      <div className="flex items-center h-full" data-id="element-388">
        {TABS.map(({
        key,
        label,
        Icon
      }) => {
        const isActive = activeTab === key;
        return <button key={key} onClick={() => onTabChange(key)} className={`flex-1 flex flex-col items-center justify-center gap-2 relative h-full transition-colors duration-150 ${isActive ? 'bg-[#0D0D0D]' : 'hover:bg-[#141414]'}`} data-id="element-389">
              <Icon className={`w-5 h-5 ${isActive ? 'text-[#C5D82D]' : 'text-[#999999]'}`} strokeWidth={isActive ? 2.5 : 2} data-id="element-390" />
              <span className={`text-[11px] font-medium leading-none ${isActive ? 'text-[#C5D82D]' : 'text-[#999999]'}`} data-id="element-391">
                {label}
              </span>
            </button>;
      })}
      </div>
    </div>;
}